module.exports = __webpack_public_path__ + "images/feature/GTD-3-c42c29580dfd8c48f4a325f4c1389a20.png";